import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: props => ({
    width: props.width, // use width from props
    flexShrink: 0,
    '& .MuiToolbar-root': {
      marginBottom: theme.spacing(1)
    },
    '& .MuiDivider-root': {
      marginTop: theme.spacing(1)
    }
  }),
  paper: props => ({
    width: props.width // use width from props
  }),
  handleRight: {
    // Make it not hidden behind the drawer
    zIndex: 100
  }
}));
